// BASE ENTRY POINT
// Entry points need to exists inside of webpack.config.js under module.exports, entry:
// Entry points is meant for the translations object.

require('../partials/base/_index.scss');
const hubSpecificJS = require('../scriptPartials/base/index');
const onbrandScripts = require('../onbrand');

const translations = {
  header: {},
  footer: {},
};

hubSpecificJS();
onbrandScripts.initOnbrand(translations, production);



// WEBPACK FOOTER //
// ./entryPoints/base.js